import { render } from "./NewApp.vue?vue&type=template&id=1d062da7&scoped=true"
import script from "./NewApp.vue?vue&type=script&lang=js"
export * from "./NewApp.vue?vue&type=script&lang=js"

import "./NewApp.vue?vue&type=style&index=0&id=1d062da7&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d062da7"]])

export default __exports__